import {DataSourceConfig, DataSourceConfigAuthenticatedUserProfile} from './data-source-config.model';
import {DefaultSchemaName} from '@app/views/admin/application-settings/models/data-source-config.model';
import {DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';

export class GSuiteConfig extends DataSourceConfig {
    archiveOU: string;
    authUrl: string;
    profile: DataSourceConfigAuthenticatedUserProfile;

    constructor(
        public importGroupsAsSections: boolean,
        public exportSectionsAsGroups: boolean,
        friendlyName: string = ''
    ) {
        super(<DefaultSchemaName>'', friendlyName);
        this.dataSourceType = DataSourceType.GoogleClassroom;
    }
}

export const GSUITE_OU_ROOT_FRIENDLY_NAME = 'Google Workspace';
